export default [
  {
    id: "glass",
    name: "Glass",
    categories: ["Web Application Icons"]
  },
  {
    id: "music",
    name: "Music",
    categories: ["Web Application Icons"]
  },
  {
    id: "search",
    name: "Search",
    categories: ["Web Application Icons"]
  },
  {
    id: "envelope-o",
    name: "Envelope Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "heart",
    name: "Heart",
    categories: ["Web Application Icons", "Medical Icons"]
  },
  {
    id: "star",
    name: "Star",
    categories: ["Web Application Icons"]
  },
  {
    id: "star-o",
    name: "Star Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "user",
    name: "User",
    categories: ["Web Application Icons"]
  },
  {
    id: "film",
    name: "Film",
    categories: ["Web Application Icons"]
  },
  {
    id: "th-large",
    name: "th-large",
    categories: ["Text Editor Icons"]
  },
  {
    id: "th",
    name: "th",
    categories: ["Text Editor Icons"]
  },
  {
    id: "th-list",
    name: "th-list",
    categories: ["Text Editor Icons"]
  },
  {
    id: "check",
    name: "Check",
    categories: ["Web Application Icons"]
  },
  {
    id: "times",
    name: "Times",
    categories: ["Web Application Icons"]
  },
  {
    id: "search-plus",
    name: "Search Plus",
    categories: ["Web Application Icons"]
  },
  {
    id: "search-minus",
    name: "Search Minus",
    categories: ["Web Application Icons"]
  },
  {
    id: "power-off",
    name: "Power Off",
    categories: ["Web Application Icons"]
  },
  {
    id: "signal",
    name: "signal",
    categories: ["Web Application Icons"]
  },
  {
    id: "cog",
    name: "cog",
    categories: ["Web Application Icons", "Spinner Icons"]
  },
  {
    id: "trash-o",
    name: "Trash Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "home",
    name: "home",
    categories: ["Web Application Icons"]
  },
  {
    id: "file-o",
    name: "File Outlined",
    categories: ["Text Editor Icons", "File Type Icons"]
  },
  {
    id: "clock-o",
    name: "Clock Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "road",
    name: "road",
    categories: ["Web Application Icons"]
  },
  {
    id: "download",
    name: "Download",
    categories: ["Web Application Icons"]
  },
  {
    id: "arrow-circle-o-down",
    name: "Arrow Circle Outlined Down",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-circle-o-up",
    name: "Arrow Circle Outlined Up",
    categories: ["Directional Icons"]
  },
  {
    id: "inbox",
    name: "inbox",
    categories: ["Web Application Icons"]
  },
  {
    id: "play-circle-o",
    name: "Play Circle Outlined",
    categories: ["Video Player Icons"]
  },
  {
    id: "repeat",
    name: "Repeat",
    categories: ["Text Editor Icons"]
  },
  {
    id: "refresh",
    name: "refresh",
    categories: ["Web Application Icons", "Spinner Icons"]
  },
  {
    id: "list-alt",
    name: "list-alt",
    categories: ["Text Editor Icons"]
  },
  {
    id: "lock",
    name: "lock",
    categories: ["Web Application Icons"]
  },
  {
    id: "flag",
    name: "flag",
    categories: ["Web Application Icons"]
  },
  {
    id: "headphones",
    name: "headphones",
    categories: ["Web Application Icons"]
  },
  {
    id: "volume-off",
    name: "volume-off",
    categories: ["Web Application Icons"]
  },
  {
    id: "volume-down",
    name: "volume-down",
    categories: ["Web Application Icons"]
  },
  {
    id: "volume-up",
    name: "volume-up",
    categories: ["Web Application Icons"]
  },
  {
    id: "qrcode",
    name: "qrcode",
    categories: ["Web Application Icons"]
  },
  {
    id: "barcode",
    name: "barcode",
    categories: ["Web Application Icons"]
  },
  {
    id: "tag",
    name: "tag",
    categories: ["Web Application Icons"]
  },
  {
    id: "tags",
    name: "tags",
    categories: ["Web Application Icons"]
  },
  {
    id: "book",
    name: "book",
    categories: ["Web Application Icons"]
  },
  {
    id: "bookmark",
    name: "bookmark",
    categories: ["Web Application Icons"]
  },
  {
    id: "print",
    name: "print",
    categories: ["Web Application Icons"]
  },
  {
    id: "camera",
    name: "camera",
    categories: ["Web Application Icons"]
  },
  {
    id: "font",
    name: "font",
    categories: ["Text Editor Icons"]
  },
  {
    id: "bold",
    name: "bold",
    categories: ["Text Editor Icons"]
  },
  {
    id: "italic",
    name: "italic",
    categories: ["Text Editor Icons"]
  },
  {
    id: "text-height",
    name: "text-height",
    categories: ["Text Editor Icons"]
  },
  {
    id: "text-width",
    name: "text-width",
    categories: ["Text Editor Icons"]
  },
  {
    id: "align-left",
    name: "align-left",
    categories: ["Text Editor Icons"]
  },
  {
    id: "align-center",
    name: "align-center",
    categories: ["Text Editor Icons"]
  },
  {
    id: "align-right",
    name: "align-right",
    categories: ["Text Editor Icons"]
  },
  {
    id: "align-justify",
    name: "align-justify",
    categories: ["Text Editor Icons"]
  },
  {
    id: "list",
    name: "list",
    categories: ["Text Editor Icons"]
  },
  {
    id: "outdent",
    name: "Outdent",
    categories: ["Text Editor Icons"]
  },
  {
    id: "indent",
    name: "Indent",
    categories: ["Text Editor Icons"]
  },
  {
    id: "video-camera",
    name: "Video Camera",
    categories: ["Web Application Icons"]
  },
  {
    id: "picture-o",
    name: "Picture Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "pencil",
    name: "pencil",
    categories: ["Web Application Icons"]
  },
  {
    id: "map-marker",
    name: "map-marker",
    categories: ["Web Application Icons"]
  },
  {
    id: "adjust",
    name: "adjust",
    categories: ["Web Application Icons"]
  },
  {
    id: "tint",
    name: "tint",
    categories: ["Web Application Icons"]
  },
  {
    id: "pencil-square-o",
    name: "Pencil Square Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "share-square-o",
    name: "Share Square Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "check-square-o",
    name: "Check Square Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "arrows",
    name: "Arrows",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "step-backward",
    name: "step-backward",
    categories: ["Video Player Icons"]
  },
  {
    id: "fast-backward",
    name: "fast-backward",
    categories: ["Video Player Icons"]
  },
  {
    id: "backward",
    name: "backward",
    categories: ["Video Player Icons"]
  },
  {
    id: "play",
    name: "play",
    categories: ["Video Player Icons"]
  },
  {
    id: "pause",
    name: "pause",
    categories: ["Video Player Icons"]
  },
  {
    id: "stop",
    name: "stop",
    categories: ["Video Player Icons"]
  },
  {
    id: "forward",
    name: "forward",
    categories: ["Video Player Icons"]
  },
  {
    id: "fast-forward",
    name: "fast-forward",
    categories: ["Video Player Icons"]
  },
  {
    id: "step-forward",
    name: "step-forward",
    categories: ["Video Player Icons"]
  },
  {
    id: "eject",
    name: "eject",
    categories: ["Video Player Icons"]
  },
  {
    id: "chevron-left",
    name: "chevron-left",
    categories: ["Directional Icons"]
  },
  {
    id: "chevron-right",
    name: "chevron-right",
    categories: ["Directional Icons"]
  },
  {
    id: "plus-circle",
    name: "Plus Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "minus-circle",
    name: "Minus Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "times-circle",
    name: "Times Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "check-circle",
    name: "Check Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "question-circle",
    name: "Question Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "info-circle",
    name: "Info Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "crosshairs",
    name: "Crosshairs",
    categories: ["Web Application Icons"]
  },
  {
    id: "times-circle-o",
    name: "Times Circle Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "check-circle-o",
    name: "Check Circle Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "ban",
    name: "ban",
    categories: ["Web Application Icons"]
  },
  {
    id: "arrow-left",
    name: "arrow-left",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-right",
    name: "arrow-right",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-up",
    name: "arrow-up",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-down",
    name: "arrow-down",
    categories: ["Directional Icons"]
  },
  {
    id: "share",
    name: "Share",
    categories: ["Web Application Icons"]
  },
  {
    id: "expand",
    name: "Expand",
    categories: ["Video Player Icons"]
  },
  {
    id: "compress",
    name: "Compress",
    categories: ["Video Player Icons"]
  },
  {
    id: "plus",
    name: "plus",
    categories: ["Web Application Icons"]
  },
  {
    id: "minus",
    name: "minus",
    categories: ["Web Application Icons"]
  },
  {
    id: "asterisk",
    name: "asterisk",
    categories: ["Web Application Icons"]
  },
  {
    id: "exclamation-circle",
    name: "Exclamation Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "gift",
    name: "gift",
    categories: ["Web Application Icons"]
  },
  {
    id: "leaf",
    name: "leaf",
    categories: ["Web Application Icons"]
  },
  {
    id: "fire",
    name: "fire",
    categories: ["Web Application Icons"]
  },
  {
    id: "eye",
    name: "Eye",
    categories: ["Web Application Icons"]
  },
  {
    id: "eye-slash",
    name: "Eye Slash",
    categories: ["Web Application Icons"]
  },
  {
    id: "exclamation-triangle",
    name: "Exclamation Triangle",
    categories: ["Web Application Icons"]
  },
  {
    id: "plane",
    name: "plane",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "calendar",
    name: "calendar",
    categories: ["Web Application Icons"]
  },
  {
    id: "random",
    name: "random",
    categories: ["Web Application Icons", "Video Player Icons"]
  },
  {
    id: "comment",
    name: "comment",
    categories: ["Web Application Icons"]
  },
  {
    id: "magnet",
    name: "magnet",
    categories: ["Web Application Icons"]
  },
  {
    id: "chevron-up",
    name: "chevron-up",
    categories: ["Directional Icons"]
  },
  {
    id: "chevron-down",
    name: "chevron-down",
    categories: ["Directional Icons"]
  },
  {
    id: "retweet",
    name: "retweet",
    categories: ["Web Application Icons"]
  },
  {
    id: "shopping-cart",
    name: "shopping-cart",
    categories: ["Web Application Icons"]
  },
  {
    id: "folder",
    name: "Folder",
    categories: ["Web Application Icons"]
  },
  {
    id: "folder-open",
    name: "Folder Open",
    categories: ["Web Application Icons"]
  },
  {
    id: "arrows-v",
    name: "Arrows Vertical",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "arrows-h",
    name: "Arrows Horizontal",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "bar-chart",
    name: "Bar Chart",
    categories: ["Web Application Icons", "Chart Icons"]
  },
  {
    id: "twitter-square",
    name: "Twitter Square",
    categories: ["Brand Icons"]
  },
  {
    id: "facebook-square",
    name: "Facebook Square",
    categories: ["Brand Icons"]
  },
  {
    id: "camera-retro",
    name: "camera-retro",
    categories: ["Web Application Icons"]
  },
  {
    id: "key",
    name: "key",
    categories: ["Web Application Icons"]
  },
  {
    id: "cogs",
    name: "cogs",
    categories: ["Web Application Icons"]
  },
  {
    id: "comments",
    name: "comments",
    categories: ["Web Application Icons"]
  },
  {
    id: "thumbs-o-up",
    name: "Thumbs Up Outlined",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "thumbs-o-down",
    name: "Thumbs Down Outlined",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "star-half",
    name: "star-half",
    categories: ["Web Application Icons"]
  },
  {
    id: "heart-o",
    name: "Heart Outlined",
    categories: ["Web Application Icons", "Medical Icons"]
  },
  {
    id: "sign-out",
    name: "Sign Out",
    categories: ["Web Application Icons"]
  },
  {
    id: "linkedin-square",
    name: "LinkedIn Square",
    categories: ["Brand Icons"]
  },
  {
    id: "thumb-tack",
    name: "Thumb Tack",
    categories: ["Web Application Icons"]
  },
  {
    id: "external-link",
    name: "External Link",
    categories: ["Web Application Icons"]
  },
  {
    id: "sign-in",
    name: "Sign In",
    categories: ["Web Application Icons"]
  },
  {
    id: "trophy",
    name: "trophy",
    categories: ["Web Application Icons"]
  },
  {
    id: "github-square",
    name: "GitHub Square",
    categories: ["Brand Icons"]
  },
  {
    id: "upload",
    name: "Upload",
    categories: ["Web Application Icons"]
  },
  {
    id: "lemon-o",
    name: "Lemon Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "phone",
    name: "Phone",
    categories: ["Web Application Icons"]
  },
  {
    id: "square-o",
    name: "Square Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "bookmark-o",
    name: "Bookmark Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "phone-square",
    name: "Phone Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "twitter",
    name: "Twitter",
    categories: ["Brand Icons"]
  },
  {
    id: "facebook",
    name: "Facebook",
    categories: ["Brand Icons"]
  },
  {
    id: "github",
    name: "GitHub",
    categories: ["Brand Icons"]
  },
  {
    id: "unlock",
    name: "unlock",
    categories: ["Web Application Icons"]
  },
  {
    id: "credit-card",
    name: "credit-card",
    categories: ["Web Application Icons", "Payment Icons"]
  },
  {
    id: "rss",
    name: "rss",
    categories: ["Web Application Icons"]
  },
  {
    id: "hdd-o",
    name: "HDD",
    categories: ["Web Application Icons"]
  },
  {
    id: "bullhorn",
    name: "bullhorn",
    categories: ["Web Application Icons"]
  },
  {
    id: "bell",
    name: "bell",
    categories: ["Web Application Icons"]
  },
  {
    id: "certificate",
    name: "certificate",
    categories: ["Web Application Icons"]
  },
  {
    id: "hand-o-right",
    name: "Hand Outlined Right",
    categories: ["Directional Icons", "Hand Icons"]
  },
  {
    id: "hand-o-left",
    name: "Hand Outlined Left",
    categories: ["Directional Icons", "Hand Icons"]
  },
  {
    id: "hand-o-up",
    name: "Hand Outlined Up",
    categories: ["Directional Icons", "Hand Icons"]
  },
  {
    id: "hand-o-down",
    name: "Hand Outlined Down",
    categories: ["Directional Icons", "Hand Icons"]
  },
  {
    id: "arrow-circle-left",
    name: "Arrow Circle Left",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-circle-right",
    name: "Arrow Circle Right",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-circle-up",
    name: "Arrow Circle Up",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-circle-down",
    name: "Arrow Circle Down",
    categories: ["Directional Icons"]
  },
  {
    id: "globe",
    name: "Globe",
    categories: ["Web Application Icons"]
  },
  {
    id: "wrench",
    name: "Wrench",
    categories: ["Web Application Icons"]
  },
  {
    id: "tasks",
    name: "Tasks",
    categories: ["Web Application Icons"]
  },
  {
    id: "filter",
    name: "Filter",
    categories: ["Web Application Icons"]
  },
  {
    id: "briefcase",
    name: "Briefcase",
    categories: ["Web Application Icons"]
  },
  {
    id: "arrows-alt",
    name: "Arrows Alt",
    categories: ["Video Player Icons", "Directional Icons"]
  },
  {
    id: "users",
    name: "Users",
    categories: ["Web Application Icons"]
  },
  {
    id: "link",
    name: "Link",
    categories: ["Text Editor Icons"]
  },
  {
    id: "cloud",
    name: "Cloud",
    categories: ["Web Application Icons"]
  },
  {
    id: "flask",
    name: "Flask",
    categories: ["Web Application Icons"]
  },
  {
    id: "scissors",
    name: "Scissors",
    categories: ["Text Editor Icons"]
  },
  {
    id: "files-o",
    name: "Files Outlined",
    categories: ["Text Editor Icons"]
  },
  {
    id: "paperclip",
    name: "Paperclip",
    categories: ["Text Editor Icons"]
  },
  {
    id: "floppy-o",
    name: "Floppy Outlined",
    categories: ["Text Editor Icons"]
  },
  {
    id: "square",
    name: "Square",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "bars",
    name: "Bars",
    categories: ["Web Application Icons"]
  },
  {
    id: "list-ul",
    name: "list-ul",
    categories: ["Text Editor Icons"]
  },
  {
    id: "list-ol",
    name: "list-ol",
    categories: ["Text Editor Icons"]
  },
  {
    id: "strikethrough",
    name: "Strikethrough",
    categories: ["Text Editor Icons"]
  },
  {
    id: "underline",
    name: "Underline",
    categories: ["Text Editor Icons"]
  },
  {
    id: "table",
    name: "table",
    categories: ["Text Editor Icons"]
  },
  {
    id: "magic",
    name: "magic",
    categories: ["Web Application Icons"]
  },
  {
    id: "truck",
    name: "truck",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "pinterest",
    name: "Pinterest",
    categories: ["Brand Icons"]
  },
  {
    id: "pinterest-square",
    name: "Pinterest Square",
    categories: ["Brand Icons"]
  },
  {
    id: "google-plus-square",
    name: "Google Plus Square",
    categories: ["Brand Icons"]
  },
  {
    id: "google-plus",
    name: "Google Plus",
    categories: ["Brand Icons"]
  },
  {
    id: "money",
    name: "Money",
    categories: ["Web Application Icons", "Currency Icons"]
  },
  {
    id: "caret-down",
    name: "Caret Down",
    categories: ["Directional Icons"]
  },
  {
    id: "caret-up",
    name: "Caret Up",
    categories: ["Directional Icons"]
  },
  {
    id: "caret-left",
    name: "Caret Left",
    categories: ["Directional Icons"]
  },
  {
    id: "caret-right",
    name: "Caret Right",
    categories: ["Directional Icons"]
  },
  {
    id: "columns",
    name: "Columns",
    categories: ["Text Editor Icons"]
  },
  {
    id: "sort",
    name: "Sort",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-desc",
    name: "Sort Descending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-asc",
    name: "Sort Ascending",
    categories: ["Web Application Icons"]
  },
  {
    id: "envelope",
    name: "Envelope",
    categories: ["Web Application Icons"]
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    categories: ["Brand Icons"]
  },
  {
    id: "undo",
    name: "Undo",
    categories: ["Text Editor Icons"]
  },
  {
    id: "gavel",
    name: "Gavel",
    categories: ["Web Application Icons"]
  },
  {
    id: "tachometer",
    name: "Tachometer",
    categories: ["Web Application Icons"]
  },
  {
    id: "comment-o",
    name: "comment-o",
    categories: ["Web Application Icons"]
  },
  {
    id: "comments-o",
    name: "comments-o",
    categories: ["Web Application Icons"]
  },
  {
    id: "bolt",
    name: "Lightning Bolt",
    categories: ["Web Application Icons"]
  },
  {
    id: "sitemap",
    name: "Sitemap",
    categories: ["Web Application Icons"]
  },
  {
    id: "umbrella",
    name: "Umbrella",
    categories: ["Web Application Icons"]
  },
  {
    id: "clipboard",
    name: "Clipboard",
    categories: ["Text Editor Icons"]
  },
  {
    id: "lightbulb-o",
    name: "Lightbulb Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "exchange",
    name: "Exchange",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "cloud-download",
    name: "Cloud Download",
    categories: ["Web Application Icons"]
  },
  {
    id: "cloud-upload",
    name: "Cloud Upload",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-md",
    name: "user-md",
    categories: ["Medical Icons"]
  },
  {
    id: "stethoscope",
    name: "Stethoscope",
    categories: ["Medical Icons"]
  },
  {
    id: "suitcase",
    name: "Suitcase",
    categories: ["Web Application Icons"]
  },
  {
    id: "bell-o",
    name: "Bell Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "coffee",
    name: "Coffee",
    categories: ["Web Application Icons"]
  },
  {
    id: "cutlery",
    name: "Cutlery",
    categories: ["Web Application Icons"]
  },
  {
    id: "file-text-o",
    name: "File Text Outlined",
    categories: ["Text Editor Icons", "File Type Icons"]
  },
  {
    id: "building-o",
    name: "Building Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "hospital-o",
    name: "hospital Outlined",
    categories: ["Medical Icons"]
  },
  {
    id: "ambulance",
    name: "ambulance",
    categories: ["Medical Icons", "Transportation Icons"]
  },
  {
    id: "medkit",
    name: "medkit",
    categories: ["Medical Icons"]
  },
  {
    id: "fighter-jet",
    name: "fighter-jet",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "beer",
    name: "beer",
    categories: ["Web Application Icons"]
  },
  {
    id: "h-square",
    name: "H Square",
    categories: ["Medical Icons"]
  },
  {
    id: "plus-square",
    name: "Plus Square",
    categories: ["Medical Icons", "Web Application Icons", "Form Control Icons"]
  },
  {
    id: "angle-double-left",
    name: "Angle Double Left",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-double-right",
    name: "Angle Double Right",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-double-up",
    name: "Angle Double Up",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-double-down",
    name: "Angle Double Down",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-left",
    name: "angle-left",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-right",
    name: "angle-right",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-up",
    name: "angle-up",
    categories: ["Directional Icons"]
  },
  {
    id: "angle-down",
    name: "angle-down",
    categories: ["Directional Icons"]
  },
  {
    id: "desktop",
    name: "Desktop",
    categories: ["Web Application Icons"]
  },
  {
    id: "laptop",
    name: "Laptop",
    categories: ["Web Application Icons"]
  },
  {
    id: "tablet",
    name: "tablet",
    categories: ["Web Application Icons"]
  },
  {
    id: "mobile",
    name: "Mobile Phone",
    categories: ["Web Application Icons"]
  },
  {
    id: "circle-o",
    name: "Circle Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "quote-left",
    name: "quote-left",
    categories: ["Web Application Icons"]
  },
  {
    id: "quote-right",
    name: "quote-right",
    categories: ["Web Application Icons"]
  },
  {
    id: "spinner",
    name: "Spinner",
    categories: ["Web Application Icons", "Spinner Icons"]
  },
  {
    id: "circle",
    name: "Circle",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "reply",
    name: "Reply",
    categories: ["Web Application Icons"]
  },
  {
    id: "github-alt",
    name: "GitHub Alt",
    categories: ["Brand Icons"]
  },
  {
    id: "folder-o",
    name: "Folder Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "folder-open-o",
    name: "Folder Open Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "smile-o",
    name: "Smile Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "frown-o",
    name: "Frown Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "meh-o",
    name: "Meh Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "gamepad",
    name: "Gamepad",
    categories: ["Web Application Icons"]
  },
  {
    id: "keyboard-o",
    name: "Keyboard Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "flag-o",
    name: "Flag Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "flag-checkered",
    name: "flag-checkered",
    categories: ["Web Application Icons"]
  },
  {
    id: "terminal",
    name: "Terminal",
    categories: ["Web Application Icons"]
  },
  {
    id: "code",
    name: "Code",
    categories: ["Web Application Icons"]
  },
  {
    id: "reply-all",
    name: "reply-all",
    categories: ["Web Application Icons"]
  },
  {
    id: "star-half-o",
    name: "Star Half Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "location-arrow",
    name: "location-arrow",
    categories: ["Web Application Icons"]
  },
  {
    id: "crop",
    name: "crop",
    categories: ["Web Application Icons"]
  },
  {
    id: "code-fork",
    name: "code-fork",
    categories: ["Web Application Icons"]
  },
  {
    id: "chain-broken",
    name: "Chain Broken",
    categories: ["Text Editor Icons"]
  },
  {
    id: "question",
    name: "Question",
    categories: ["Web Application Icons"]
  },
  {
    id: "info",
    name: "Info",
    categories: ["Web Application Icons"]
  },
  {
    id: "exclamation",
    name: "exclamation",
    categories: ["Web Application Icons"]
  },
  {
    id: "superscript",
    name: "superscript",
    categories: ["Text Editor Icons"]
  },
  {
    id: "subscript",
    name: "subscript",
    categories: ["Text Editor Icons"]
  },
  {
    id: "eraser",
    name: "eraser",
    categories: ["Text Editor Icons", "Web Application Icons"]
  },
  {
    id: "puzzle-piece",
    name: "Puzzle Piece",
    categories: ["Web Application Icons"]
  },
  {
    id: "microphone",
    name: "microphone",
    categories: ["Web Application Icons"]
  },
  {
    id: "microphone-slash",
    name: "Microphone Slash",
    categories: ["Web Application Icons"]
  },
  {
    id: "shield",
    name: "shield",
    categories: ["Web Application Icons"]
  },
  {
    id: "calendar-o",
    name: "calendar-o",
    categories: ["Web Application Icons"]
  },
  {
    id: "fire-extinguisher",
    name: "fire-extinguisher",
    categories: ["Web Application Icons"]
  },
  {
    id: "rocket",
    name: "rocket",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "maxcdn",
    name: "MaxCDN",
    categories: ["Brand Icons"]
  },
  {
    id: "chevron-circle-left",
    name: "Chevron Circle Left",
    categories: ["Directional Icons"]
  },
  {
    id: "chevron-circle-right",
    name: "Chevron Circle Right",
    categories: ["Directional Icons"]
  },
  {
    id: "chevron-circle-up",
    name: "Chevron Circle Up",
    categories: ["Directional Icons"]
  },
  {
    id: "chevron-circle-down",
    name: "Chevron Circle Down",
    categories: ["Directional Icons"]
  },
  {
    id: "html5",
    name: "HTML 5 Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "css3",
    name: "CSS 3 Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "anchor",
    name: "Anchor",
    categories: ["Web Application Icons"]
  },
  {
    id: "unlock-alt",
    name: "Unlock Alt",
    categories: ["Web Application Icons"]
  },
  {
    id: "bullseye",
    name: "Bullseye",
    categories: ["Web Application Icons"]
  },
  {
    id: "ellipsis-h",
    name: "Ellipsis Horizontal",
    categories: ["Web Application Icons"]
  },
  {
    id: "ellipsis-v",
    name: "Ellipsis Vertical",
    categories: ["Web Application Icons"]
  },
  {
    id: "rss-square",
    name: "RSS Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "play-circle",
    name: "Play Circle",
    categories: ["Video Player Icons"]
  },
  {
    id: "ticket",
    name: "Ticket",
    categories: ["Web Application Icons"]
  },
  {
    id: "minus-square",
    name: "Minus Square",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "minus-square-o",
    name: "Minus Square Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "level-up",
    name: "Level Up",
    categories: ["Web Application Icons"]
  },
  {
    id: "level-down",
    name: "Level Down",
    categories: ["Web Application Icons"]
  },
  {
    id: "check-square",
    name: "Check Square",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "pencil-square",
    name: "Pencil Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "external-link-square",
    name: "External Link Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "share-square",
    name: "Share Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "compass",
    name: "Compass",
    categories: ["Web Application Icons"]
  },
  {
    id: "caret-square-o-down",
    name: "Caret Square Outlined Down",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "caret-square-o-up",
    name: "Caret Square Outlined Up",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "caret-square-o-right",
    name: "Caret Square Outlined Right",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "eur",
    name: "Euro (EUR)",
    categories: ["Currency Icons"]
  },
  {
    id: "gbp",
    name: "GBP",
    categories: ["Currency Icons"]
  },
  {
    id: "usd",
    name: "US Dollar",
    categories: ["Currency Icons"]
  },
  {
    id: "inr",
    name: "Indian Rupee (INR)",
    categories: ["Currency Icons"]
  },
  {
    id: "jpy",
    name: "Japanese Yen (JPY)",
    categories: ["Currency Icons"]
  },
  {
    id: "rub",
    name: "Russian Ruble (RUB)",
    categories: ["Currency Icons"]
  },
  {
    id: "krw",
    name: "Korean Won (KRW)",
    categories: ["Currency Icons"]
  },
  {
    id: "btc",
    name: "Bitcoin (BTC)",
    categories: ["Currency Icons", "Brand Icons"]
  },
  {
    id: "file",
    name: "File",
    categories: ["Text Editor Icons", "File Type Icons"]
  },
  {
    id: "file-text",
    name: "File Text",
    categories: ["Text Editor Icons", "File Type Icons"]
  },
  {
    id: "sort-alpha-asc",
    name: "Sort Alpha Ascending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-alpha-desc",
    name: "Sort Alpha Descending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-amount-asc",
    name: "Sort Amount Ascending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-amount-desc",
    name: "Sort Amount Descending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-numeric-asc",
    name: "Sort Numeric Ascending",
    categories: ["Web Application Icons"]
  },
  {
    id: "sort-numeric-desc",
    name: "Sort Numeric Descending",
    categories: ["Web Application Icons"]
  },
  {
    id: "thumbs-up",
    name: "thumbs-up",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "thumbs-down",
    name: "thumbs-down",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "youtube-square",
    name: "YouTube Square",
    categories: ["Brand Icons"]
  },
  {
    id: "youtube",
    name: "YouTube",
    categories: ["Brand Icons"]
  },
  {
    id: "xing",
    name: "Xing",
    categories: ["Brand Icons"]
  },
  {
    id: "xing-square",
    name: "Xing Square",
    categories: ["Brand Icons"]
  },
  {
    id: "youtube-play",
    name: "YouTube Play",
    categories: ["Brand Icons", "Video Player Icons"]
  },
  {
    id: "dropbox",
    name: "Dropbox",
    categories: ["Brand Icons"]
  },
  {
    id: "stack-overflow",
    name: "Stack Overflow",
    categories: ["Brand Icons"]
  },
  {
    id: "instagram",
    name: "Instagram",
    categories: ["Brand Icons"]
  },
  {
    id: "flickr",
    name: "Flickr",
    categories: ["Brand Icons"]
  },
  {
    id: "adn",
    name: "App.net",
    categories: ["Brand Icons"]
  },
  {
    id: "bitbucket",
    name: "Bitbucket",
    categories: ["Brand Icons"]
  },
  {
    id: "bitbucket-square",
    name: "Bitbucket Square",
    categories: ["Brand Icons"]
  },
  {
    id: "tumblr",
    name: "Tumblr",
    categories: ["Brand Icons"]
  },
  {
    id: "tumblr-square",
    name: "Tumblr Square",
    categories: ["Brand Icons"]
  },
  {
    id: "long-arrow-down",
    name: "Long Arrow Down",
    categories: ["Directional Icons"]
  },
  {
    id: "long-arrow-up",
    name: "Long Arrow Up",
    categories: ["Directional Icons"]
  },
  {
    id: "long-arrow-left",
    name: "Long Arrow Left",
    categories: ["Directional Icons"]
  },
  {
    id: "long-arrow-right",
    name: "Long Arrow Right",
    categories: ["Directional Icons"]
  },
  {
    id: "apple",
    name: "Apple",
    categories: ["Brand Icons"]
  },
  {
    id: "windows",
    name: "Windows",
    categories: ["Brand Icons"]
  },
  {
    id: "android",
    name: "Android",
    categories: ["Brand Icons"]
  },
  {
    id: "linux",
    name: "Linux",
    categories: ["Brand Icons"]
  },
  {
    id: "dribbble",
    name: "Dribbble",
    categories: ["Brand Icons"]
  },
  {
    id: "skype",
    name: "Skype",
    categories: ["Brand Icons"]
  },
  {
    id: "foursquare",
    name: "Foursquare",
    categories: ["Brand Icons"]
  },
  {
    id: "trello",
    name: "Trello",
    categories: ["Brand Icons"]
  },
  {
    id: "female",
    name: "Female",
    categories: ["Web Application Icons"]
  },
  {
    id: "male",
    name: "Male",
    categories: ["Web Application Icons"]
  },
  {
    id: "gratipay",
    name: "Gratipay (Gittip)",
    categories: ["Brand Icons"]
  },
  {
    id: "sun-o",
    name: "Sun Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "moon-o",
    name: "Moon Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "archive",
    name: "Archive",
    categories: ["Web Application Icons"]
  },
  {
    id: "bug",
    name: "Bug",
    categories: ["Web Application Icons"]
  },
  {
    id: "vk",
    name: "VK",
    categories: ["Brand Icons"]
  },
  {
    id: "weibo",
    name: "Weibo",
    categories: ["Brand Icons"]
  },
  {
    id: "renren",
    name: "Renren",
    categories: ["Brand Icons"]
  },
  {
    id: "pagelines",
    name: "Pagelines",
    categories: ["Brand Icons"]
  },
  {
    id: "stack-exchange",
    name: "Stack Exchange",
    categories: ["Brand Icons"]
  },
  {
    id: "arrow-circle-o-right",
    name: "Arrow Circle Outlined Right",
    categories: ["Directional Icons"]
  },
  {
    id: "arrow-circle-o-left",
    name: "Arrow Circle Outlined Left",
    categories: ["Directional Icons"]
  },
  {
    id: "caret-square-o-left",
    name: "Caret Square Outlined Left",
    categories: ["Web Application Icons", "Directional Icons"]
  },
  {
    id: "dot-circle-o",
    name: "Dot Circle Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "wheelchair",
    name: "Wheelchair",
    categories: [
      "Web Application Icons",
      "Medical Icons",
      "Transportation Icons",
      "Accessibility Icons"
    ]
  },
  {
    id: "vimeo-square",
    name: "Vimeo Square",
    categories: ["Brand Icons"]
  },
  {
    id: "try",
    name: "Turkish Lira (TRY)",
    categories: ["Currency Icons"]
  },
  {
    id: "plus-square-o",
    name: "Plus Square Outlined",
    categories: ["Web Application Icons", "Form Control Icons"]
  },
  {
    id: "space-shuttle",
    name: "Space Shuttle",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "slack",
    name: "Slack Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "envelope-square",
    name: "Envelope Square",
    categories: ["Web Application Icons"]
  },
  {
    id: "wordpress",
    name: "WordPress Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "openid",
    name: "OpenID",
    categories: ["Brand Icons"]
  },
  {
    id: "university",
    name: "University",
    categories: ["Web Application Icons"]
  },
  {
    id: "graduation-cap",
    name: "Graduation Cap",
    categories: ["Web Application Icons"]
  },
  {
    id: "yahoo",
    name: "Yahoo Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "google",
    name: "Google Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "reddit",
    name: "reddit Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "reddit-square",
    name: "reddit Square",
    categories: ["Brand Icons"]
  },
  {
    id: "stumbleupon-circle",
    name: "StumbleUpon Circle",
    categories: ["Brand Icons"]
  },
  {
    id: "stumbleupon",
    name: "StumbleUpon Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "delicious",
    name: "Delicious Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "digg",
    name: "Digg Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "pied-piper-pp",
    name: "Pied Piper PP Logo (Old)",
    categories: ["Brand Icons"]
  },
  {
    id: "pied-piper-alt",
    name: "Pied Piper Alternate Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "drupal",
    name: "Drupal Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "joomla",
    name: "Joomla Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "language",
    name: "Language",
    categories: ["Web Application Icons"]
  },
  {
    id: "fax",
    name: "Fax",
    categories: ["Web Application Icons"]
  },
  {
    id: "building",
    name: "Building",
    categories: ["Web Application Icons"]
  },
  {
    id: "child",
    name: "Child",
    categories: ["Web Application Icons"]
  },
  {
    id: "paw",
    name: "Paw",
    categories: ["Web Application Icons"]
  },
  {
    id: "spoon",
    name: "spoon",
    categories: ["Web Application Icons"]
  },
  {
    id: "cube",
    name: "Cube",
    categories: ["Web Application Icons"]
  },
  {
    id: "cubes",
    name: "Cubes",
    categories: ["Web Application Icons"]
  },
  {
    id: "behance",
    name: "Behance",
    categories: ["Brand Icons"]
  },
  {
    id: "behance-square",
    name: "Behance Square",
    categories: ["Brand Icons"]
  },
  {
    id: "steam",
    name: "Steam",
    categories: ["Brand Icons"]
  },
  {
    id: "steam-square",
    name: "Steam Square",
    categories: ["Brand Icons"]
  },
  {
    id: "recycle",
    name: "Recycle",
    categories: ["Web Application Icons"]
  },
  {
    id: "car",
    name: "Car",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "taxi",
    name: "Taxi",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "tree",
    name: "Tree",
    categories: ["Web Application Icons"]
  },
  {
    id: "spotify",
    name: "Spotify",
    categories: ["Brand Icons"]
  },
  {
    id: "deviantart",
    name: "deviantART",
    categories: ["Brand Icons"]
  },
  {
    id: "soundcloud",
    name: "SoundCloud",
    categories: ["Brand Icons"]
  },
  {
    id: "database",
    name: "Database",
    categories: ["Web Application Icons"]
  },
  {
    id: "file-pdf-o",
    name: "PDF File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-word-o",
    name: "Word File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-excel-o",
    name: "Excel File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-powerpoint-o",
    name: "Powerpoint File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-image-o",
    name: "Image File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-archive-o",
    name: "Archive File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-audio-o",
    name: "Audio File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-video-o",
    name: "Video File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "file-code-o",
    name: "Code File Outlined",
    categories: ["Web Application Icons", "File Type Icons"]
  },
  {
    id: "vine",
    name: "Vine",
    categories: ["Brand Icons"]
  },
  {
    id: "codepen",
    name: "Codepen",
    categories: ["Brand Icons"]
  },
  {
    id: "jsfiddle",
    name: "jsFiddle",
    categories: ["Brand Icons"]
  },
  {
    id: "life-ring",
    name: "Life Ring",
    categories: ["Web Application Icons"]
  },
  {
    id: "circle-o-notch",
    name: "Circle Outlined Notched",
    categories: ["Web Application Icons", "Spinner Icons"]
  },
  {
    id: "rebel",
    name: "Rebel Alliance",
    categories: ["Brand Icons"]
  },
  {
    id: "empire",
    name: "Galactic Empire",
    categories: ["Brand Icons"]
  },
  {
    id: "git-square",
    name: "Git Square",
    categories: ["Brand Icons"]
  },
  {
    id: "git",
    name: "Git",
    categories: ["Brand Icons"]
  },
  {
    id: "hacker-news",
    name: "Hacker News",
    categories: ["Brand Icons"]
  },
  {
    id: "tencent-weibo",
    name: "Tencent Weibo",
    categories: ["Brand Icons"]
  },
  {
    id: "qq",
    name: "QQ",
    categories: ["Brand Icons"]
  },
  {
    id: "weixin",
    name: "Weixin (WeChat)",
    categories: ["Brand Icons"]
  },
  {
    id: "paper-plane",
    name: "Paper Plane",
    categories: ["Web Application Icons"]
  },
  {
    id: "paper-plane-o",
    name: "Paper Plane Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "history",
    name: "History",
    categories: ["Web Application Icons"]
  },
  {
    id: "circle-thin",
    name: "Circle Outlined Thin",
    categories: ["Web Application Icons"]
  },
  {
    id: "header",
    name: "header",
    categories: ["Text Editor Icons"]
  },
  {
    id: "paragraph",
    name: "paragraph",
    categories: ["Text Editor Icons"]
  },
  {
    id: "sliders",
    name: "Sliders",
    categories: ["Web Application Icons"]
  },
  {
    id: "share-alt",
    name: "Share Alt",
    categories: ["Web Application Icons", "Brand Icons"]
  },
  {
    id: "share-alt-square",
    name: "Share Alt Square",
    categories: ["Web Application Icons", "Brand Icons"]
  },
  {
    id: "bomb",
    name: "Bomb",
    categories: ["Web Application Icons"]
  },
  {
    id: "futbol-o",
    name: "Futbol Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "tty",
    name: "TTY",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "binoculars",
    name: "Binoculars",
    categories: ["Web Application Icons"]
  },
  {
    id: "plug",
    name: "Plug",
    categories: ["Web Application Icons"]
  },
  {
    id: "slideshare",
    name: "Slideshare",
    categories: ["Brand Icons"]
  },
  {
    id: "twitch",
    name: "Twitch",
    categories: ["Brand Icons"]
  },
  {
    id: "yelp",
    name: "Yelp",
    categories: ["Brand Icons"]
  },
  {
    id: "newspaper-o",
    name: "Newspaper Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "wifi",
    name: "WiFi",
    categories: ["Web Application Icons"]
  },
  {
    id: "calculator",
    name: "Calculator",
    categories: ["Web Application Icons"]
  },
  {
    id: "paypal",
    name: "Paypal",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "google-wallet",
    name: "Google Wallet",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-visa",
    name: "Visa Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-mastercard",
    name: "MasterCard Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-discover",
    name: "Discover Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-amex",
    name: "American Express Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-paypal",
    name: "Paypal Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-stripe",
    name: "Stripe Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "bell-slash",
    name: "Bell Slash",
    categories: ["Web Application Icons"]
  },
  {
    id: "bell-slash-o",
    name: "Bell Slash Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "trash",
    name: "Trash",
    categories: ["Web Application Icons"]
  },
  {
    id: "copyright",
    name: "Copyright",
    categories: ["Web Application Icons"]
  },
  {
    id: "at",
    name: "At",
    categories: ["Web Application Icons"]
  },
  {
    id: "eyedropper",
    name: "Eyedropper",
    categories: ["Web Application Icons"]
  },
  {
    id: "paint-brush",
    name: "Paint Brush",
    categories: ["Web Application Icons"]
  },
  {
    id: "birthday-cake",
    name: "Birthday Cake",
    categories: ["Web Application Icons"]
  },
  {
    id: "area-chart",
    name: "Area Chart",
    categories: ["Web Application Icons", "Chart Icons"]
  },
  {
    id: "pie-chart",
    name: "Pie Chart",
    categories: ["Web Application Icons", "Chart Icons"]
  },
  {
    id: "line-chart",
    name: "Line Chart",
    categories: ["Web Application Icons", "Chart Icons"]
  },
  {
    id: "lastfm",
    name: "last.fm",
    categories: ["Brand Icons"]
  },
  {
    id: "lastfm-square",
    name: "last.fm Square",
    categories: ["Brand Icons"]
  },
  {
    id: "toggle-off",
    name: "Toggle Off",
    categories: ["Web Application Icons"]
  },
  {
    id: "toggle-on",
    name: "Toggle On",
    categories: ["Web Application Icons"]
  },
  {
    id: "bicycle",
    name: "Bicycle",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "bus",
    name: "Bus",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "ioxhost",
    name: "ioxhost",
    categories: ["Brand Icons"]
  },
  {
    id: "angellist",
    name: "AngelList",
    categories: ["Brand Icons"]
  },
  {
    id: "cc",
    name: "Closed Captions",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "ils",
    name: "Shekel (ILS)",
    categories: ["Currency Icons"]
  },
  {
    id: "meanpath",
    name: "meanpath",
    categories: ["Brand Icons"]
  },
  {
    id: "buysellads",
    name: "BuySellAds",
    categories: ["Brand Icons"]
  },
  {
    id: "connectdevelop",
    name: "Connect Develop",
    categories: ["Brand Icons"]
  },
  {
    id: "dashcube",
    name: "DashCube",
    categories: ["Brand Icons"]
  },
  {
    id: "forumbee",
    name: "Forumbee",
    categories: ["Brand Icons"]
  },
  {
    id: "leanpub",
    name: "Leanpub",
    categories: ["Brand Icons"]
  },
  {
    id: "sellsy",
    name: "Sellsy",
    categories: ["Brand Icons"]
  },
  {
    id: "shirtsinbulk",
    name: "Shirts in Bulk",
    categories: ["Brand Icons"]
  },
  {
    id: "simplybuilt",
    name: "SimplyBuilt",
    categories: ["Brand Icons"]
  },
  {
    id: "skyatlas",
    name: "skyatlas",
    categories: ["Brand Icons"]
  },
  {
    id: "cart-plus",
    name: "Add to Shopping Cart",
    categories: ["Web Application Icons"]
  },
  {
    id: "cart-arrow-down",
    name: "Shopping Cart Arrow Down",
    categories: ["Web Application Icons"]
  },
  {
    id: "diamond",
    name: "Diamond",
    categories: ["Web Application Icons"]
  },
  {
    id: "ship",
    name: "Ship",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "user-secret",
    name: "User Secret",
    categories: ["Web Application Icons"]
  },
  {
    id: "motorcycle",
    name: "Motorcycle",
    categories: ["Web Application Icons", "Transportation Icons"]
  },
  {
    id: "street-view",
    name: "Street View",
    categories: ["Web Application Icons"]
  },
  {
    id: "heartbeat",
    name: "Heartbeat",
    categories: ["Web Application Icons", "Medical Icons"]
  },
  {
    id: "venus",
    name: "Venus",
    categories: ["Gender Icons"]
  },
  {
    id: "mars",
    name: "Mars",
    categories: ["Gender Icons"]
  },
  {
    id: "mercury",
    name: "Mercury",
    categories: ["Gender Icons"]
  },
  {
    id: "transgender",
    name: "Transgender",
    categories: ["Gender Icons"]
  },
  {
    id: "transgender-alt",
    name: "Transgender Alt",
    categories: ["Gender Icons"]
  },
  {
    id: "venus-double",
    name: "Venus Double",
    categories: ["Gender Icons"]
  },
  {
    id: "mars-double",
    name: "Mars Double",
    categories: ["Gender Icons"]
  },
  {
    id: "venus-mars",
    name: "Venus Mars",
    categories: ["Gender Icons"]
  },
  {
    id: "mars-stroke",
    name: "Mars Stroke",
    categories: ["Gender Icons"]
  },
  {
    id: "mars-stroke-v",
    name: "Mars Stroke Vertical",
    categories: ["Gender Icons"]
  },
  {
    id: "mars-stroke-h",
    name: "Mars Stroke Horizontal",
    categories: ["Gender Icons"]
  },
  {
    id: "neuter",
    name: "Neuter",
    categories: ["Gender Icons"]
  },
  {
    id: "genderless",
    name: "Genderless",
    categories: ["Gender Icons"]
  },
  {
    id: "facebook-official",
    name: "Facebook Official",
    categories: ["Brand Icons"]
  },
  {
    id: "pinterest-p",
    name: "Pinterest P",
    categories: ["Brand Icons"]
  },
  {
    id: "whatsapp",
    name: "What's App",
    categories: ["Brand Icons"]
  },
  {
    id: "server",
    name: "Server",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-plus",
    name: "Add User",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-times",
    name: "Remove User",
    categories: ["Web Application Icons"]
  },
  {
    id: "bed",
    name: "Bed",
    categories: ["Web Application Icons"]
  },
  {
    id: "viacoin",
    name: "Viacoin",
    categories: ["Brand Icons"]
  },
  {
    id: "train",
    name: "Train",
    categories: ["Transportation Icons"]
  },
  {
    id: "subway",
    name: "Subway",
    categories: ["Transportation Icons"]
  },
  {
    id: "medium",
    name: "Medium",
    categories: ["Brand Icons"]
  },
  {
    id: "y-combinator",
    name: "Y Combinator",
    categories: ["Brand Icons"]
  },
  {
    id: "optin-monster",
    name: "Optin Monster",
    categories: ["Brand Icons"]
  },
  {
    id: "opencart",
    name: "OpenCart",
    categories: ["Brand Icons"]
  },
  {
    id: "expeditedssl",
    name: "ExpeditedSSL",
    categories: ["Brand Icons"]
  },
  {
    id: "battery-full",
    name: "Battery Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "battery-three-quarters",
    name: "Battery 3/4 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "battery-half",
    name: "Battery 1/2 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "battery-quarter",
    name: "Battery 1/4 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "battery-empty",
    name: "Battery Empty",
    categories: ["Web Application Icons"]
  },
  {
    id: "mouse-pointer",
    name: "Mouse Pointer",
    categories: ["Web Application Icons"]
  },
  {
    id: "i-cursor",
    name: "I Beam Cursor",
    categories: ["Web Application Icons"]
  },
  {
    id: "object-group",
    name: "Object Group",
    categories: ["Web Application Icons"]
  },
  {
    id: "object-ungroup",
    name: "Object Ungroup",
    categories: ["Web Application Icons"]
  },
  {
    id: "sticky-note",
    name: "Sticky Note",
    categories: ["Web Application Icons"]
  },
  {
    id: "sticky-note-o",
    name: "Sticky Note Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "cc-jcb",
    name: "JCB Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "cc-diners-club",
    name: "Diner's Club Credit Card",
    categories: ["Brand Icons", "Payment Icons"]
  },
  {
    id: "clone",
    name: "Clone",
    categories: ["Web Application Icons"]
  },
  {
    id: "balance-scale",
    name: "Balance Scale",
    categories: ["Web Application Icons"]
  },
  {
    id: "hourglass-o",
    name: "Hourglass Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "hourglass-start",
    name: "Hourglass Start",
    categories: ["Web Application Icons"]
  },
  {
    id: "hourglass-half",
    name: "Hourglass Half",
    categories: ["Web Application Icons"]
  },
  {
    id: "hourglass-end",
    name: "Hourglass End",
    categories: ["Web Application Icons"]
  },
  {
    id: "hourglass",
    name: "Hourglass",
    categories: ["Web Application Icons"]
  },
  {
    id: "hand-rock-o",
    name: "Rock (Hand)",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-paper-o",
    name: "Paper (Hand)",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-scissors-o",
    name: "Scissors (Hand)",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-lizard-o",
    name: "Lizard (Hand)",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-spock-o",
    name: "Spock (Hand)",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-pointer-o",
    name: "Hand Pointer",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "hand-peace-o",
    name: "Hand Peace",
    categories: ["Web Application Icons", "Hand Icons"]
  },
  {
    id: "trademark",
    name: "Trademark",
    categories: ["Web Application Icons"]
  },
  {
    id: "registered",
    name: "Registered Trademark",
    categories: ["Web Application Icons"]
  },
  {
    id: "creative-commons",
    name: "Creative Commons",
    categories: ["Web Application Icons"]
  },
  {
    id: "gg",
    name: "GG Currency",
    categories: ["Currency Icons", "Brand Icons"]
  },
  {
    id: "gg-circle",
    name: "GG Currency Circle",
    categories: ["Currency Icons", "Brand Icons"]
  },
  {
    id: "tripadvisor",
    name: "TripAdvisor",
    categories: ["Brand Icons"]
  },
  {
    id: "odnoklassniki",
    name: "Odnoklassniki",
    categories: ["Brand Icons"]
  },
  {
    id: "odnoklassniki-square",
    name: "Odnoklassniki Square",
    categories: ["Brand Icons"]
  },
  {
    id: "get-pocket",
    name: "Get Pocket",
    categories: ["Brand Icons"]
  },
  {
    id: "wikipedia-w",
    name: "Wikipedia W",
    categories: ["Brand Icons"]
  },
  {
    id: "safari",
    name: "Safari",
    categories: ["Brand Icons"]
  },
  {
    id: "chrome",
    name: "Chrome",
    categories: ["Brand Icons"]
  },
  {
    id: "firefox",
    name: "Firefox",
    categories: ["Brand Icons"]
  },
  {
    id: "opera",
    name: "Opera",
    categories: ["Brand Icons"]
  },
  {
    id: "internet-explorer",
    name: "Internet-explorer",
    categories: ["Brand Icons"]
  },
  {
    id: "television",
    name: "Television",
    categories: ["Web Application Icons"]
  },
  {
    id: "contao",
    name: "Contao",
    categories: ["Brand Icons"]
  },
  {
    id: "500px",
    name: "500px",
    categories: ["Brand Icons"]
  },
  {
    id: "amazon",
    name: "Amazon",
    categories: ["Brand Icons"]
  },
  {
    id: "calendar-plus-o",
    name: "Calendar Plus Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "calendar-minus-o",
    name: "Calendar Minus Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "calendar-times-o",
    name: "Calendar Times Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "calendar-check-o",
    name: "Calendar Check Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "industry",
    name: "Industry",
    categories: ["Web Application Icons"]
  },
  {
    id: "map-pin",
    name: "Map Pin",
    categories: ["Web Application Icons"]
  },
  {
    id: "map-signs",
    name: "Map Signs",
    categories: ["Web Application Icons"]
  },
  {
    id: "map-o",
    name: "Map Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "map",
    name: "Map",
    categories: ["Web Application Icons"]
  },
  {
    id: "commenting",
    name: "Commenting",
    categories: ["Web Application Icons"]
  },
  {
    id: "commenting-o",
    name: "Commenting Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "houzz",
    name: "Houzz",
    categories: ["Brand Icons"]
  },
  {
    id: "vimeo",
    name: "Vimeo",
    categories: ["Brand Icons"]
  },
  {
    id: "black-tie",
    name: "Font Awesome Black Tie",
    categories: ["Brand Icons"]
  },
  {
    id: "fonticons",
    name: "Fonticons",
    categories: ["Brand Icons"]
  },
  {
    id: "reddit-alien",
    name: "reddit Alien",
    categories: ["Brand Icons"]
  },
  {
    id: "edge",
    name: "Edge Browser",
    categories: ["Brand Icons"]
  },
  {
    id: "credit-card-alt",
    name: "Credit Card",
    categories: ["Payment Icons", "Web Application Icons"]
  },
  {
    id: "codiepie",
    name: "Codie Pie",
    categories: ["Brand Icons"]
  },
  {
    id: "modx",
    name: "MODX",
    categories: ["Brand Icons"]
  },
  {
    id: "fort-awesome",
    name: "Fort Awesome",
    categories: ["Brand Icons"]
  },
  {
    id: "usb",
    name: "USB",
    categories: ["Brand Icons"]
  },
  {
    id: "product-hunt",
    name: "Product Hunt",
    categories: ["Brand Icons"]
  },
  {
    id: "mixcloud",
    name: "Mixcloud",
    categories: ["Brand Icons"]
  },
  {
    id: "scribd",
    name: "Scribd",
    categories: ["Brand Icons"]
  },
  {
    id: "pause-circle",
    name: "Pause Circle",
    categories: ["Video Player Icons"]
  },
  {
    id: "pause-circle-o",
    name: "Pause Circle Outlined",
    categories: ["Video Player Icons"]
  },
  {
    id: "stop-circle",
    name: "Stop Circle",
    categories: ["Video Player Icons"]
  },
  {
    id: "stop-circle-o",
    name: "Stop Circle Outlined",
    categories: ["Video Player Icons"]
  },
  {
    id: "shopping-bag",
    name: "Shopping Bag",
    categories: ["Web Application Icons"]
  },
  {
    id: "shopping-basket",
    name: "Shopping Basket",
    categories: ["Web Application Icons"]
  },
  {
    id: "hashtag",
    name: "Hashtag",
    categories: ["Web Application Icons"]
  },
  {
    id: "bluetooth",
    name: "Bluetooth",
    categories: ["Web Application Icons", "Brand Icons"]
  },
  {
    id: "bluetooth-b",
    name: "Bluetooth",
    categories: ["Web Application Icons", "Brand Icons"]
  },
  {
    id: "percent",
    name: "Percent",
    categories: ["Web Application Icons"]
  },
  {
    id: "gitlab",
    name: "GitLab",
    categories: ["Brand Icons"]
  },
  {
    id: "wpbeginner",
    name: "WPBeginner",
    categories: ["Brand Icons"]
  },
  {
    id: "wpforms",
    name: "WPForms",
    categories: ["Brand Icons"]
  },
  {
    id: "envira",
    name: "Envira Gallery",
    categories: ["Brand Icons"]
  },
  {
    id: "universal-access",
    name: "Universal Access",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "wheelchair-alt",
    name: "Wheelchair Alt",
    categories: [
      "Web Application Icons",
      "Medical Icons",
      "Transportation Icons",
      "Accessibility Icons"
    ]
  },
  {
    id: "question-circle-o",
    name: "Question Circle Outlined",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "blind",
    name: "Blind",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "audio-description",
    name: "Audio Description",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "volume-control-phone",
    name: "Volume Control Phone",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "braille",
    name: "Braille",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "assistive-listening-systems",
    name: "Assistive Listening Systems",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "american-sign-language-interpreting",
    name: "American Sign Language Interpreting",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "deaf",
    name: "Deaf",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "glide",
    name: "Glide",
    categories: ["Brand Icons"]
  },
  {
    id: "glide-g",
    name: "Glide G",
    categories: ["Brand Icons"]
  },
  {
    id: "sign-language",
    name: "Sign Language",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "low-vision",
    name: "Low Vision",
    categories: ["Web Application Icons", "Accessibility Icons"]
  },
  {
    id: "viadeo",
    name: "Viadeo",
    categories: ["Brand Icons"]
  },
  {
    id: "viadeo-square",
    name: "Viadeo Square",
    categories: ["Brand Icons"]
  },
  {
    id: "snapchat",
    name: "Snapchat",
    categories: ["Brand Icons"]
  },
  {
    id: "snapchat-ghost",
    name: "Snapchat Ghost",
    categories: ["Brand Icons"]
  },
  {
    id: "snapchat-square",
    name: "Snapchat Square",
    categories: ["Brand Icons"]
  },
  {
    id: "pied-piper",
    name: "Pied Piper Logo",
    categories: ["Brand Icons"]
  },
  {
    id: "first-order",
    name: "First Order",
    categories: ["Brand Icons"]
  },
  {
    id: "yoast",
    name: "Yoast",
    categories: ["Brand Icons"]
  },
  {
    id: "themeisle",
    name: "ThemeIsle",
    categories: ["Brand Icons"]
  },
  {
    id: "google-plus-official",
    name: "Google Plus Official",
    categories: ["Brand Icons"]
  },
  {
    id: "font-awesome",
    name: "Font Awesome",
    categories: ["Brand Icons"]
  },
  {
    id: "handshake-o",
    name: "Handshake Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "envelope-open",
    name: "Envelope Open",
    categories: ["Web Application Icons"]
  },
  {
    id: "envelope-open-o",
    name: "Envelope Open Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "linode",
    name: "Linode",
    categories: ["Brand Icons"]
  },
  {
    id: "address-book",
    name: "Address Book",
    categories: ["Web Application Icons"]
  },
  {
    id: "address-book-o",
    name: "Address Book Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "address-card",
    name: "Address Card",
    categories: ["Web Application Icons"]
  },
  {
    id: "address-card-o",
    name: "Address Card Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-circle",
    name: "User Circle",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-circle-o",
    name: "User Circle Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "user-o",
    name: "User Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "id-badge",
    name: "Identification Badge",
    categories: ["Web Application Icons"]
  },
  {
    id: "id-card",
    name: "Identification Card",
    categories: ["Web Application Icons"]
  },
  {
    id: "id-card-o",
    name: "Identification Card Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "quora",
    name: "Quora",
    categories: ["Brand Icons"]
  },
  {
    id: "free-code-camp",
    name: "Free Code Camp",
    categories: ["Brand Icons"]
  },
  {
    id: "telegram",
    name: "Telegram",
    categories: ["Brand Icons"]
  },
  {
    id: "thermometer-full",
    name: "Thermometer Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "thermometer-three-quarters",
    name: "Thermometer 3/4 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "thermometer-half",
    name: "Thermometer 1/2 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "thermometer-quarter",
    name: "Thermometer 1/4 Full",
    categories: ["Web Application Icons"]
  },
  {
    id: "thermometer-empty",
    name: "Thermometer Empty",
    categories: ["Web Application Icons"]
  },
  {
    id: "shower",
    name: "Shower",
    categories: ["Web Application Icons"]
  },
  {
    id: "bath",
    name: "Bath",
    categories: ["Web Application Icons"]
  },
  {
    id: "podcast",
    name: "Podcast",
    categories: ["Web Application Icons"]
  },
  {
    id: "window-maximize",
    name: "Window Maximize",
    categories: ["Web Application Icons"]
  },
  {
    id: "window-minimize",
    name: "Window Minimize",
    categories: ["Web Application Icons"]
  },
  {
    id: "window-restore",
    name: "Window Restore",
    categories: ["Web Application Icons"]
  },
  {
    id: "window-close",
    name: "Window Close",
    categories: ["Web Application Icons"]
  },
  {
    id: "window-close-o",
    name: "Window Close Outline",
    categories: ["Web Application Icons"]
  },
  {
    id: "bandcamp",
    name: "Bandcamp",
    categories: ["Brand Icons"]
  },
  {
    id: "grav",
    name: "Grav",
    categories: ["Brand Icons"]
  },
  {
    id: "etsy",
    name: "Etsy",
    categories: ["Brand Icons"]
  },
  {
    id: "imdb",
    name: "IMDB",
    categories: ["Brand Icons"]
  },
  {
    id: "ravelry",
    name: "Ravelry",
    categories: ["Brand Icons"]
  },
  {
    id: "eercast",
    name: "Eercast",
    categories: ["Brand Icons"]
  },
  {
    id: "microchip",
    name: "Microchip",
    categories: ["Web Application Icons"]
  },
  {
    id: "snowflake-o",
    name: "Snowflake Outlined",
    categories: ["Web Application Icons"]
  },
  {
    id: "superpowers",
    name: "Superpowers",
    categories: ["Brand Icons"]
  },
  {
    id: "wpexplorer",
    name: "WPExplorer",
    categories: ["Brand Icons"]
  },
  {
    id: "meetup",
    name: "Meetup",
    categories: ["Brand Icons"]
  }
];



// WEBPACK FOOTER //
// ./src/properties/faicons.js